<template>
    <div class="layout-sidebar">
        <div class="sidebar">
            <ul class="sidebar-menu">
                <li v-for="item in sideberMap" :key="item.name">
                    <router-link :to="{name: item.name}" :class="[item.className, item.name === activeName?'active':'']">
                        <img :src="item.name === activeName? item.selected : item.url"/>
                        <div>
                            {{ item.text }}
                             <i v-if="item.text === '历史课程' && unCorrectList.length" class="red-point"></i>
                        </div>
                    </router-link>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
import schedule from '../../../assets/images/common/dh_icon_kb_default.png';
import scheduleSelected from '../../../assets/images/common/dh_icon_kb_pressed.png';
import history from '../../../assets/images/common/dh_icon_kc_default.png';
import historySelected from '../../../assets/images/common/dh_icon_kc_pressed.png';
import Vue from 'vue';
export default {
    data() {
        return {
            sideberMap: [
                {
                    url: schedule,
                    selected: scheduleSelected,
                    name: 'schedule@course',
                    text: '我的课表',
                    className: 'sidebar-schedule'
                },
                {
                    url: history,
                    selected: historySelected,
                    name: 'history@course',
                    text: '历史课程',
                    className: 'sidebar-history'
                }
            ],
            unCorrectList: [] // 作业中心、历史课程不为空时显示小红点

        };
    },
    computed: {
        // 高亮侧边栏name
        activeName() {
            let name = this.$route.name;
            let targetName = '';
            if (name) {
                if (name.indexOf('schedule@') > -1) {
                    targetName = 'schedule@course';
                } else if (name.indexOf('history@') > -1) {
                    targetName = 'history@course';
                }
            }
            return targetName;
        }
    },
    beforeMount() {
        this.getHomeworkList();
    },
    methods: {
        getHomeworkList() {
            Vue.http.get('/v1/homework/list', { params: {
                studentUsername: '',
                homeworkStatus: '',
                start: 0,
                limit: 10
            } })
                .then(resp => this.$checkResp(resp, {}))
                .then(data => {
                    data.homework && data.homework.forEach((item, index) => {
                        if (item.hwStatus === 2) {
                            this.unCorrectList.push(index);
                        }
                    });
                });
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.sidebar {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    box-sizing: border-box;
    overflow-y: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
}

.sidebar-menu {
    a {
        display: flex;
        height: 90px;
        justify-content: center;
        align-items: center;
        color: #cccccc;
        flex-direction: column;
        // padding-left: 44px;
        text-decoration: none;

        img {
            width: 22px;
            margin-bottom: 10px;
        }

        div {
            position: relative;
            // margin-top: 10px;

            i {
                position: absolute;
                right: -15px;
                top: 0;
            }
        }

        &:hover {
            background-color: #fafafa;
        }

        &.active {
            text-decoration: none;
            color: #F4664B;
            background-image: url('../../../assets/images/common/dh_icon_tiao.png');
            background-repeat: no-repeat;
            background-position: 0 center;
            background-size: 6px;
        }

        &.sidebar-schedule {
            i {
                background: url(../../../assets/images/common/nav_schedule_default.png) no-repeat;
                background-size: contain;
            }

            &:hover i,
            &.active i {
                background: url(../../../assets/images/common/nav_schedule_selected.png) no-repeat;
                background-size: contain;
            }
        }

        &.sidebar-student {
            i {
                background: url(../../../assets/images/common/nav_student_default.png) no-repeat;
                background-size: contain;
            }

            &:hover i,
            &.active i {
                background: url(../../../assets/images/common/nav_student_selected.png) no-repeat;
                background-size: contain;
            }
        }

        &.sidebar-history {
            i {
                background: url(../../../assets/images/common/nav_history_default.png) no-repeat;
                background-size: contain;
            }

            &:hover i,
            &.active i {
                background: url(../../../assets/images/common/nav_history_selected.png) no-repeat;
                background-size: contain;
            }
        }

        &.sidebar-setting {
            i {
                background: url(../../../assets/images/common/nav_setting_default.png) no-repeat;
                background-size: contain;
            }

            &:hover i,
            &.active i {
                background: url(../../../assets/images/common/nav_setting_selected.png) no-repeat;
                background-size: contain;
            }
        }

        &.sidebar-homework {
            i {
                background: url(../../../assets/images/common/nav_work_default.png) no-repeat;
                background-size: contain;
            }

            &:hover i,
            &.active i {
                background: url(../../../assets/images/common/nav_work_selected.png) no-repeat;
                background-size: contain;
            }
        }

        &.sidebar-evaluation {
            i {
                background: url(../../../assets/images/common/nav_work_default.png) no-repeat;
                background-size: contain;
            }

            &:hover i,
            &.active i {
                background: url(../../../assets/images/common/nav_work_selected.png) no-repeat;
                background-size: contain;
            }
        }

        .red-point {
            width: 8px;
            height: 8px;
            background-color: #f4664b !important;
            background-image: none !important;
            margin-left: 5px;
            margin-right: 0;
            border-radius: 50%;
        }
    }
}

.sidebar-service {
    position: absolute;
    left: 20px;
    bottom: 20px;
    width: 160px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #4abef9;
    color: #fff;
    font-size: 14px;
    cursor: pointer;

    &:hover {
        background-color: lighten(#4abef9, 3%);
    }

    i {
        vertical-align: middle;
        margin-right: 5px;
        font-size: 20px;
    }
}
::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/AppSidebarNew.vue